import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

import Images from '../utils/Images';

const MENU_EASE = [0.22, 1, 0.36, 1];

function CategoryItem({
    name,
    image,
    active,
    onClick,
    index = 0,
    prefersReducedMotion = false,
    canAnimate = false
}) {
    const hidden = {
        opacity: 0,
        y: 14,
        scale: 0.92
    };

    const visible = {
        opacity: 1,
        y: 0,
        scale: 1
    };

    return (
        <Box
            component={motion.div}
            initial={
                prefersReducedMotion
                    ? false
                    : hidden
            }
            animate={
                prefersReducedMotion
                    ? visible
                    : canAnimate
                        ? visible
                        : hidden
            }
            transition={
                prefersReducedMotion
                    ? { duration: 0 }
                    : {
                        duration: 0.4,
                        delay: canAnimate
                            ? 0.24 + index * 0.045
                            : 0,
                        ease: MENU_EASE
                    }
            }
            onClick={onClick}
            sx={{
                flex: '0 0 auto',
                width: 74,
                cursor: 'pointer',
                textAlign: 'center'
            }}
        >
            <Box
                component={motion.div}
                animate={
                    active
                        ? { scale: 1.04 }
                        : { scale: 1 }
                }
                transition={{
                    duration: prefersReducedMotion
                        ? 0
                        : 0.22,
                    ease: MENU_EASE
                }}
                sx={{
                    width: 74,
                    height: 74,
                    mx: 'auto',
                    borderRadius: '50%',
                    p: '3px',
                    mt: 0.5,
                    border: active
                        ? '3px solid #FFE600'
                        : 'none',
                    boxSizing: 'border-box',
                    display: 'grid',
                    placeItems: 'center',
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        component="img"
                        src={image || Images.product}
                        alt={name}
                        onError={(event) => {
                            event.currentTarget.onerror = null;
                            event.currentTarget.src = Images.product;
                        }}
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block'
                        }}
                    />
                </Box>
            </Box>

            <Typography
                sx={{
                    mt: 0.7,
                    px: 0.2,
                    minHeight: 26,
                    fontSize: 10.5,
                    fontWeight: active ? 600 : 500,
                    color: active ? '#09A5F7' : '#12364D',
                    textTransform: 'uppercase',
                    letterSpacing: 0.15,
                    lineHeight: 1.2,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    wordBreak: 'break-word'
                }}
            >
                {name}
            </Typography>
        </Box>
    );
}

export default CategoryItem;
